import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { AuthDialogStepEnum } from '../gb-auth-dialog.models'

@Injectable({
  providedIn: 'root',
})
export class GbAuthDialogViewService {
  authDialogStepSubject$ = new BehaviorSubject<string>(AuthDialogStepEnum.Initial)
  authDialogStep$ = this.authDialogStepSubject$.asObservable()

  goToRegister(): void {
    this.authDialogStepSubject$.next(AuthDialogStepEnum.Register)
  }

  goToLogin(): void {
    this.authDialogStepSubject$.next(AuthDialogStepEnum.Login)
  }

  goToInitial(): void {
    this.authDialogStepSubject$.next(AuthDialogStepEnum.Initial)
  }
}
